import _get from 'lodash/get';
import cartApi from '../cart/api';
import * as cartActions from '../cart/actions';
import * as types from './actionTypes';

export const showFreeSaucesPanel = (goodId, sauces = [], freeCount) => {
  return dispatch => {
    if (sauces.length) {
      return dispatch({ type: types.SHOW_PANEL, payload: { sauces, goodId, freeCount } });
    }

    return null;
  };
};

export function hideFreeSaucesPanel() {
  return dispatch => {
    dispatch(hidePanel());

    setTimeout(() => {
      return dispatch(cleanFreeSauces());
    }, 350);
  };
}

function hidePanel() {
  return { type: types.HIDE_PANEL };
}

function cleanFreeSauces() {
  return { type: types.CLEAN_FREE_SAUCES };
}

function addFreeSauceStart(id) {
  return { type: types.ADD_TO_CART_REQUEST, payload: { id } };
}

function addFreeSauceDone(id) {
  return { type: types.ADD_TO_CART_SUCCESS, payload: { id } };
}

function addFreeSauceFail(id, error) {
  return {
    type: types.ADD_TO_CART_FAILURE,
    payload: { id, error },
  };
}

export const addFreeSauce = (sauceId, variationId) => {
  return (dispatch, getState) => {
    const {
      freeSauces: { goodId },
      cart: { composition },
    } = getState();
    const good = composition.find(good => good.item.id === goodId);
    const includeSauces = _get(good, 'item.added_sauces', []).map(sauce => sauce.id);

    dispatch(addFreeSauceStart(sauceId));
    return cartApi
      .updateItem({ ...good, sauces: [variationId, ...includeSauces] })
      .then(data => {
        dispatch(cartActions.itemsUpdate(data));
        return dispatch(addFreeSauceDone(sauceId));
      })
      .catch(({ message }) => dispatch(addFreeSauceFail(sauceId, message)));
  };
};
